import { useTranslation } from "react-i18next";

import SearchOffIcon from "@mui/icons-material/SearchOff";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import type { CourseTreeProps } from "./types";
import RoleTreeItem from "./RoleTreeItem";

const CourseTree = ({ roles, expandedNodeIds, searchTerm }: CourseTreeProps) => {
  const { t } = useTranslation();

  if (searchTerm && roles.length === 0) {
    return (
      <Paper
        variant="outlined"
        elevation={0}
        sx={{
          backgroundColor: (theme) => theme.palette.grey[50],
          border: (theme) => `2px dashed ${theme.palette.divider}`,
        }}
      >
        <Box
          sx={{
            p: 4,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <SearchOffIcon
            sx={{
              fontSize: 48,
              color: "text.disabled",
              opacity: 0.5,
            }}
          />
          <Box>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                color: "text.secondary",
              }}
            >
              {t("relations_tree.no_results_title")}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "text.disabled",
              }}
            >
              {t("relations_tree.no_results_description", { searchTerm })}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "text.disabled",
                mt: 1,
              }}
            >
              {t("relations_tree.no_results_hint")}
            </Typography>
          </Box>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper variant="outlined" elevation={0}>
      <List dense>
        {roles.map((role) => (
          <RoleTreeItem key={role.id} role={role} nodeId="" expandedNodeIds={expandedNodeIds} searchTerm={searchTerm} />
        ))}
      </List>
    </Paper>
  );
};

export default CourseTree;
